import { render, staticRenderFns } from "./PainelProjetosGerente.vue?vue&type=template&id=342f7f39"
import script from "./PainelProjetosGerente.vue?vue&type=script&lang=js"
export * from "./PainelProjetosGerente.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosGerente.vue?vue&type=style&index=0&id=342f7f39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports